import React from "react";
import ReactDOM from "react-dom/client";
// Bootstrap first: index.css carries this app's theme overrides, and several
// of them tie with Bootstrap on specificity (`[data-theme="dark"] .form-control`
// against `.form-control:disabled`, for one). Loading ours second lets them win.
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import AuthProvider from "./context/AuthProvider";
import LeagueProvider from "./context/LeagueProvider";
import LeagueMembershipProvider from "./context/LeagueMembershipProvider";
import ThemeProvider from "./context/ThemeProvider";
import { ToastProvider } from "./context/ToastProvider";
import InitialLoadingScreen from "./components/InitialLoadingScreen";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <LeagueProvider>
          <LeagueMembershipProvider>
            <ToastProvider>
              <InitialLoadingScreen>
                <App />
              </InitialLoadingScreen>
            </ToastProvider>
          </LeagueMembershipProvider>
        </LeagueProvider>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
